// @flow
import ErrorString from './ErrorString';

export default ErrorString;
